import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { NgxGaugeModule } from 'ngx-gauge';
import { GaugeChartComponent } from './gauge.component';

@NgModule({
  declarations: [
    GaugeChartComponent
  ],
  imports: [
    FuseSharedModule,
    NgxGaugeModule,
  ],
  exports: [
    GaugeChartComponent
  ]
})
export class GaugeChartModule { }
